import React, { useCallback } from "react";
import { observer } from "mobx-react-lite";

import "./VideoProgressBar.scss";
import VideoSlider from "./components/VideoSlider";
import useTheme from "../../../../services/theme-service/ThemeService";
import { videoPlayerService } from "../../../../services/video-player/VideoPlayerService";
import { Segmentation } from "../../../../api-models/response/VideoAnalysisDataResponse";
import { SegmentationService } from "../../../../services/segmentation/SegmentationService";

export default observer(function VideoProgressBar({
  videoSegmentation,
  filteredSegmentations,
}: {
  videoSegmentation?: SegmentationService;
  filteredSegmentations?: Segmentation[];
}) {
  const { themeClass } = useTheme();
  const { videoLoadedSeconds, videoProgress, setVideoProgress, jumpTo, videoDuration } =
    videoPlayerService;

  const updatePlayerState = useCallback(
    (time: number) => {
      setVideoProgress(time);
      jumpTo(time);
    },
    [jumpTo, setVideoProgress]
  );

  return (
    <div className={themeClass(["video-progress-bar"])}>
      <VideoSlider
        videoDuration={videoDuration}
        currentTime={videoProgress}
        onChange={updatePlayerState}
        bufferedTime={videoLoadedSeconds}
        videoSegmentation={videoSegmentation}
        filteredSegmentations={filteredSegmentations}
      />
    </div>
  );
});
